import React, { useState, useEffect, useRef } from "react";
import { Header } from "../../components/ui/Header";
// import HistoryCard from "../../components/ui/HistoryCard";
import Typograpy from "../../components/ui/Typography";
import {
  deleteTransaction,
  downloadOtherTransactionHistory,
  downloadPdf,
  downloadTransactionHistory,
  // getTransactionData,
  getTransactionHistory,
  getTransactionHistoryConvera,
  getTransactionHistoryOther,
  uploadDocs,
} from "../../services/history";
import { CloseIcon, Cloud } from "../../assets/Icons";
import * as FileSaver from "file-saver";
import { CircularProgress } from "@material-ui/core";
import ErrorField from "../../components/ui/ErrorField";
import Button from "../../components/ui/Button";
import Pagination from "../../components/ui/Pagination";
import moment from "moment";
import { historyPageYearList } from "../../utils";
import NewHistoryCard from "../../components/ui/NewHistoryCard";
import Dropdown from "../../components/ui/Dropdown";
import Modal from "../../components/ui/Modal";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  fromDateState,
  historyPageEsignModal,
  historyPageSelectedTransaction,
  remitterID,
  selectedTransactionID,
  selectedTransactionRejectionStatus,
  toDateState,
} from "../../store";
import { toast } from "react-toastify";
import EsignHistoryModal from "./EsignModalHistory";
import download from "downloadjs";
import { HistoryPageEsignModalProps } from "../../store/store";
import TabShifter from "../../components/ui/TabShifter";
import CrossBG from "../../assets/svg/CrossBG.svg";
import Tick from "../../assets/svg/tick.svg";
import Datepicker, {
  DateValueType,
} from "react-tailwindcss-datepicker";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import NoHistoryBanner from "../../assets/Icons/NoHistoryBanner";

interface FormData {
  docType: string;
  file: File | null;
}

interface IHistoryTrxnPageProps {
  page: number;
  size: number;
  ascending: boolean;
  filter: string;
  fromDate: string;
  toDate: string;
  tab?: string;
}

type TabKeys = "Online" | "Flywire" | "Offline" | "Travel Card" | "Convera";

const HistoryPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const fileInputRefs = React.useRef<Array<HTMLInputElement | any>>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [transactions, setTransactions] = useState<any[]>([]);
  const [newSelectedTrxn, setNewSelectedTrxn] = useRecoilState(
    historyPageSelectedTransaction
  );
  const [isAllDocumentUpload, setIsAllDocumentUpload] =
    useState<boolean>(false);
  const [fetchTxnErrMsg, setFetchTxnErrMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const isConveraFromURL = typeof window !== "undefined" && window.location.search.includes("convera");
  const [selectedTab, setSelectedTab] = useState<TabKeys>(isConveraFromURL ? "Convera" : "Online");
  const remitterId = useRecoilValue(remitterID);
  // const [selectedTransaction, setSelectedTransaction] = useState("");
  // const [trxnData, setTrxnData] = useState<any>({});
  const [, setPDFDownloadLoad] = React.useState<boolean>(false);
  const [, setDownloadPdfErrMsg] = React.useState("");
  const [isEsignModal, setIsEsignModal] =
    useRecoilState<HistoryPageEsignModalProps>(historyPageEsignModal);
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
    ascending: false,
    totalElements: 0,
    totalPages: 0,
  });
  const [date, setDate] = useState({
    fromDate: moment().month(0).date(1).format("YYYY-MM-DD").toString(),
    toDate: moment().month(11).date(31).format("YYYY-MM-DD").toString(),
  });
  const rejectTrxnStatus = useRecoilValue(selectedTransactionRejectionStatus);
  const [formData, setFormData] = React.useState<FormData[]>([
    { docType: "Loan Disbursement letter", file: null },
  ]);
  const [showDropdowns, setShowDropdowns] = React.useState(
    Array(formData.length).fill(false)
  );
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [uploadDocErrMsg, setUploadDocErrMsg] = React.useState("");
  const historyPageSelectedTransactionID = useRecoilValue<string>(
    selectedTransactionID
  );
  const [customLoad, setCustomLoad] = React.useState({
    cancelTransactionLoad: false,
    uploadDocsLoad: false,
    imageDownload: false,
  });
  const [cancelTransactionError, setCancenTransactionError] =
    React.useState("");
  const [isCancelModalOpen, setIsCancelModalOpen] = React.useState(false);

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  const [fromDate, setFromDate] = useRecoilState(fromDateState);
  const [toDate, setToDate] = useRecoilState(toDateState);

  const location = useLocation();

  const prevLocationRef = useRef<any>(null);


  useEffect(() => {
    const currentPath = location.pathname;
 
    if (currentPath === "/history") {
      if (prevLocationRef.current !== "/history") {
        resetDatesToDefault();
      }
      prevLocationRef.current = currentPath;
    }
  }, [location.pathname, location.search]);

  const formatLocalDate = (date: Date) => {
    return date.toLocaleDateString("en-CA"); 
  };

  const handleValueChange = (newValue: DateValueType) => {
    if (newValue && typeof newValue === "object" && "startDate" in newValue && "endDate" in newValue) {
      setFromDate(newValue.startDate ? formatLocalDate(newValue.startDate) : "");
      setToDate(newValue.endDate ? formatLocalDate(newValue.endDate) : "");
    } else {
      setFromDate("");
      setToDate("");
    }
  };

  const safeDate = (dateStr: string | null | undefined): Date | null => {
    const parsed = dateStr ? dayjs(dateStr).toDate() : null;
    return parsed instanceof Date && !isNaN(parsed.getTime()) ? parsed : null;
  };

const resetDatesToDefault = () => {
  setFromDate(dayjs().subtract(1, "month").format("YYYY-MM-DD"));
  setToDate(dayjs().format("YYYY-MM-DD"));
};

  const toggleDropdown = (index: any) => {
    const updatedShowDropdowns = [...showDropdowns];
    for (let i = 0; i < formData.length; i++) {
      if (i !== index) {
        updatedShowDropdowns[i] = false;
      } else {
        updatedShowDropdowns[i] = !updatedShowDropdowns[i];
      }
    }
    setShowDropdowns(updatedShowDropdowns);
  };

  const handleDropdownChange = (index: number, value: string) => {
    const updatedFormData = [...formData];
    updatedFormData[index].docType = value;
    setFormData(updatedFormData);
  };

  const handleFileChange = (index: number, file: File | null) => {
    const updatedFormData = [...formData];
    updatedFormData[index].file = file;
    updatedFormData[index].docType =
      updatedFormData[index].docType === ""
        ? "Loan Disbursement letter"
        : updatedFormData[index].docType;
    setFormData(updatedFormData);
  };

  const clearFileInput = () => {
    fileInputRefs.current = fileInputRefs.current.slice(0, formData.length);
    while (fileInputRefs.current.length < formData.length) {
      fileInputRefs.current.push(null);
    }
    fileInputRefs.current.forEach((ref) => {
      if (ref) {
        ref.value = null;
      }
    });
  };

  const handleRemoveFile = (index: number) => {
    if (index === 0) {
      // If it's the first index, only remove the file
      const updatedFormData = [...formData];
      updatedFormData[index].file = null;
      setFormData(updatedFormData);
    } else {
      // For other indices, remove the entire entry
      const updatedFormData = formData.filter((_, i) => i !== index);
      setFormData(updatedFormData);
    }
  };

  const handleTabShifter = (newTab: TabKeys) => {
    setSelectedTab(newTab);
    // setSelectedRowId("");
    // setSelectedTrxn("");
  };

  const cancelTransaction = () => {
    setCustomLoad((prev) => ({ ...prev, cancelTransactionLoad: true }));
    setCancenTransactionError("");
    deleteTransaction(currentUser, historyPageSelectedTransactionID)
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        setCancenTransactionError(
          err.response.data.error.type ||
          "Failed to cancel transaction. Please try again"
        );
      })
      .finally(() =>
        setCustomLoad((prev) => ({ ...prev, cancelTransactionLoad: false }))
      );
  };

  const handleAddField = () => {
    setFormData([
      ...formData,
      { docType: "Loan Disbursement letter", file: null },
    ]);
  };

  const handleLinkSent = () => {
    setIsEsignModal(() => ({ isModalOpen: true, modalName: "" }));
  };

  const handleClearUploadModal = () => {
    setCustomLoad({
      cancelTransactionLoad: false,
      uploadDocsLoad: false,
      imageDownload: false,
    });
    setFormData([{ docType: "Loan Disbursement letter", file: null }]);
    setIsAllDocumentUpload(false);
    setUploadDocErrMsg("");
  };

  const handleUploadDocs = () => {
    setCustomLoad((prev) => ({ ...prev, uploadDocsLoad: true }));
    formData.map((doc) => {
      const data: any = new FormData();
      data.append("file", doc.file);
      data.append("doc_type", doc.docType.toLowerCase());
      data.append("uploadedAllDocument", isAllDocumentUpload);

      uploadDocs(currentUser, newSelectedTrxn, data)
        .then((response: any) => {
          if (response?.data?.success) {
            setIsModalOpen(false);
            setNewSelectedTrxn("");
            toast.success("Document uploaded successfully.");
            handleClearUploadModal();
            // window.location.reload();
          } else {
            setUploadDocErrMsg(response?.response?.data?.error?.type);
            setFormData([{ docType: "Loan Disbursement letter", file: null }]);
          }
        })
        .catch((error) => {
          setUploadDocErrMsg(error?.response?.data?.error?.type);
        })
        .finally(() =>
          setCustomLoad((prev) => ({ ...prev, uploadDocsLoad: false }))
        );
    });
  };

  const handlePdfDownload = (doc: any) => {
    setPDFDownloadLoad(true);
    setDownloadPdfErrMsg("");
    downloadPdf(currentUser, newSelectedTrxn, doc)
      .then((res: any) => {
        const content = res.headers["content-type"];
        download(res.data, "download_" + doc + ".pdf", content);
      })
      .catch((err) => {
        toast.error(err.response.data.error.type);
        if (err.response.status === 500) {
          setDownloadPdfErrMsg("Internal Server Error, Please try again");
        }
      })
      .finally(() => setPDFDownloadLoad(false));
  };

  const buildRequestBody = (
    selectedTab: string,
    pagination: { page: number; size: number; ascending: boolean },
    searchTerm: string,
    fromDate: string,
    toDate: string 
  ): IHistoryTrxnPageProps => {
    const tab =
      selectedTab === "Flywire"
        ? "Flywire"
        : selectedTab === "Offline"
          ? "Offline"
          : selectedTab === "Travel Card"
            ? "TravelCard"
          : selectedTab === "Convera"
            ? "Convera"
            : "Online";

    return {
      page: pagination.page,
      size: pagination.size,
      ascending: pagination.ascending,
      filter: searchTerm,
      fromDate: fromDate,
      toDate: toDate,
      ...(selectedTab !== "Online" && { tab }), 
    };
  };

  useEffect(() => {
    setIsLoading(true);
    setFetchTxnErrMsg("");

    const body: IHistoryTrxnPageProps = buildRequestBody(
      selectedTab,
      pagination,
      searchTerm,
      fromDate,
      toDate
    );

    const handleError = (err: any) => {
      const errorType = err?.response?.data?.error?.type || "";
const errorMessage =
  errorType === "missing servlet Request Parameter"
    ? "Please select the date range"
    : errorType || "Failed to fetch transactions. Please try again";
setFetchTxnErrMsg(errorMessage);
      setTransactions([]);
      setIsLoading(false);
    };

    if (selectedTab === "Online") {
      getTransactionHistory(body)
        .then((res: any) => {
          const { content, size, totalElements, totalPages } = res.data;
          setTransactions(content);
          setPagination((prev) => ({
            ...prev,
            size,
            totalElements,
            totalPages,
          }));
        })
        .catch(handleError)
        .finally(() => setIsLoading(false));
    } 
    else if (selectedTab === "Convera"){
      getTransactionHistoryConvera(body)
        .then((res) => {
          const { content, size, totalElements, totalPages } = res?.data;
          setTransactions(content);
          setPagination((prev) => ({
            ...prev,
            size,
            totalElements,
            totalPages,
          }));
        })
        .catch(handleError)
        .finally(() => setIsLoading(false));
    }
    else {
      getTransactionHistoryOther(body)
        .then((res) => {
          const { content, size, totalElements, totalPages } = res?.data;
          setTransactions(content);
          setPagination((prev) => ({
            ...prev,
            size,
            totalElements,
            totalPages,
          }));
        })
        .catch(handleError)
        .finally(() => setIsLoading(false));
    }
  }, [searchTerm, pagination.size, pagination.page, fromDate,toDate, selectedTab]);

  const tableColumns = {
    Online: [
      "Date",
      "Transaction no.",
      "Remitter",
      "Recipient",
      "Amount",
      "FX Rates",
      // "Platform",
      "Status",
      "Vendor Code",
    ],
    Flywire: [
      "Date of Transaction",
      "Flywire Reference",
      "They Receive",
      "USD Equivalent",
      "Vendor Code",
      "Status of Transaction",
    ],
    Offline: [
      "Date of Transaction",
      "Transaction number",
      "Remitter Name",
      "Transaction Amount",
      "Vendor Code",
      "Partner",
      "Status of Transaction",
    ],
    "Travel Card": [
      "Date of Transaction",
      "Transaction number",
      "Remitter Name",
      "Transaction Amount",
      "Vendor Code",
      "Partner",
      "Status of Transaction",
    ],
    "Convera": [
      "Date of Transaction",
      "Convera reference ID",
      "Remitter Name",
      "Transaction Amount",
      "Vendor Code",
      "Partner",
      "Status of Transaction",
    ],
  };
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const handleDownloadHistory = () => {
    setLoading(true);
    if (selectedTab === "Online") {
      downloadTransactionHistory(currentUser,fromDate, toDate)
        .then((response) => {
          const blobData = new Blob([response?.data], { type: fileType });
          FileSaver.saveAs(blobData, "Transaction-history.xlsx");
        })
        .catch(() => {
          window.alert("Failed to download transactions. Please try again");
        })
        .finally(() => setLoading(false));
    } else {
      const body = {
        fromDate: fromDate,
        toDate: toDate,
        tab: selectedTab?.replace(" ", ""),
      };
      downloadOtherTransactionHistory(body, currentUser)
        .then((response) => {
          const blobData = new Blob([response?.data], { type: fileType });
          FileSaver.saveAs(blobData, "Transaction-history.xlsx");
        })
        .catch(() => {
          window.alert("Failed to download transactions. Please try again");
        })
        .finally(() => setLoading(false));
    }
  };

  const handleYearChange = (year: number) => {
    setDate({
      fromDate: moment()
        .year(year)
        .month(0)
        .date(1)
        .format("YYYY-MM-DD")
        .toString(),
      toDate: moment()
        .year(year)
        .month(11)
        .date(31)
        .format("YYYY-MM-DD")
        .toString(),
    });
  };

  const isMoneyHopUser = currentUser?.username?.includes("moneyhop.co")
    ? true
    : false;



  return (
    <div className="flex flex-col">
      <Header />
      <div className="py-8 px-10 w-full">
        <div className="flex items-center justify-between w-full">
          <div className="flex justify-start items-center w-full">
            <div className="flex justify-start items-center w-full">
              <Typograpy tagType="div" className="text-2xl font-semibold whitespace-nowrap">
                Total Transaction: {isLoading ? "NA" : pagination.totalElements}
              </Typograpy>
              <input
                placeholder={selectedTab === "Online" ? "Search by Txn No." : "Search by vendor code/remitter name "}
                className="w-full px-8 py-3 mx-4 bg-[#F8F8F8] rounded-full outline-none"
                value={searchTerm}
                onChange={(e: any) => setSearchTerm(e.target.value)}
                autoComplete="off"
                pattern="[a-zA-Z0-9 ]{1,}"
              />
            </div>
            {/* <div className="flex justify-start items-center">
              <p className="font-normal">Year</p>
              <div className="px-4">
                <select
                  className="bg-[#F4F4F4] p-4 py-3 border border-gray-300 rounded-md"
                  onChange={(e) => handleYearChange(parseInt(e.target.value))}
                >
                  {historyPageYearList.map((x, index) => (
                    <option
                      style={{ padding: "2px" }}
                      className="bg-white shadow-md p-2 rounded-sm"
                      value={x}
                      key={index}
                    >
                      {x}
                    </option>
                  ))}
                </select>
              </div>
            </div> */}
          </div>
          
           <div className="flex justify-end items-center gap-3 w-full">
            <div className="bg-white rounded-lg border border-gray-300 w-2/5">
              <Datepicker
                minDate={new Date("2018-01-01")}
                maxDate={new Date()}
                showShortcuts={true}
                showFooter={true}
                value={{
                  startDate: safeDate(fromDate),
                  endDate: safeDate(toDate),
                }}
                onChange={handleValueChange}
                separator="to"
                popoverDirection="down"
                startFrom={safeDate(fromDate) || new Date()}
                primaryColor="indigo"
              />
            </div>
          <Button
            onClickHandler={handleDownloadHistory}
            className="flex px-4 py-2 space-x-2 font-bold text-white transition-all rounded-full bg-primary hover:scale-105"
            disabled={isLoading}
            isLoading={loading}
          >
            <span className="mt-1">
              <Cloud />
            </span>
            <span>Txn History</span>
          </Button>
          </div>
        </div>
        <div className="w-full relative pt-8">
          <TabShifter
            list={
              isMoneyHopUser
                ? ["Online", "Flywire", "Offline", "Travel Card","Convera"]
                : ["Online","Flywire","Convera"]
            }
            selectedItem={selectedTab}
            handleClick={handleTabShifter}
          />
        </div>
        <div className="flex items-center justify-between bg-gray-200 text-black p-2 font-medium w-full mt-2 backdrop-blur-md rounded-md">
          <div
            className="grid text-center w-full"
            style={{
              gridTemplateColumns:
                selectedTab === "Online"
                  ? `repeat(${tableColumns["Online"].length}, minmax(0, 1fr))`
                  : selectedTab === "Flywire"
                  ? `repeat(6, minmax(0, 1fr))`
                  : selectedTab === "Convera" 
                  ? `repeat(7, minmax(0, 1fr))`
                  : `repeat(7, minmax(0, 1fr))`
            }}
          >
            {tableColumns[selectedTab].map((column: string, idx: number) => (
              <span key={idx}>{column}</span>
            ))}
          </div>
        </div>
        <div>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : fetchTxnErrMsg !== "" ? (
            <ErrorField
              errorMessage={fetchTxnErrMsg}
              errorClassname="text-red-500"
            />
          ) : transactions.length <= 0 ? (
            <div className="m-auto mt-20">
            <div className="flex items-center justify-center w-full">
            <div className="h-[250px]">
              <h1 className="text-xl text-primary-600 my-8 w-full">You do not have any transactions.</h1>
                  <NoHistoryBanner />
            </div>
          </div>
            </div>
          ) : (
                  <div className="overflow-y-auto w-full" style={{ maxHeight: "600px" }}>
                    <NewHistoryCard
                      transactions={transactions}
                      pagination={pagination}
                      setIsModalOpen={setIsModalOpen}
                      selectedTab={selectedTab}
                      setIsCancelModalOpen={setIsCancelModalOpen}
                    />
                  </div>
          )}
        </div>
      </div>
      <div className="px-28">
        <Pagination
          pageSize={pagination.size}
          setPagination={setPagination}
          currentPage={pagination.page}
          totalItems={pagination.totalElements}
          pagination={pagination}
        />
      </div>
      <EsignHistoryModal
        handleA2Form={() => handlePdfDownload("A2_FORM")}
        isResign={true}
        isEsignModal={isEsignModal}
        setIsEsignModal={setIsEsignModal}
        handleLinkSent={handleLinkSent}
        remitterId={remitterId}
      />
      <Modal
        animation={true}
        visible={isModalOpen}
        closeHandler={() => {
          setIsModalOpen(false);
          handleClearUploadModal();
        }}
        header="Upload Supporting Docs"
        modalClass="rounded-md pt-1 pb-2"
        headerClass="font-medium text-2xl"
      >
        <div className="mt-3">
          <Typograpy tagType="span" className="font-normal text-sm">
            Please upload scanned image of the document
          </Typograpy>
          <div>
            {formData.map((data, index) => (
              <div
                key={index}
                className="form-group flex items-center justify-between py-3"
              >
                <Dropdown
                  showDropdown={showDropdowns[index]}
                  dropdownButtonOnClick={() => toggleDropdown(index)}
                  dropdownLabel={"Loan Disbursement letter"}
                  onBlur={() => toggleDropdown("close")}
                  dropDownValueClassNameApply={true}
                  list={[
                    "Loan Disbursement letter",
                    "Payment Confirmation",
                    "Self Declaration",
                    "University Letter",
                    "Travel Tickets",
                    "Bank Statement",
                    "Visa",
                    "Others",
                  ]}
                  dropdownClassname="w-auto p-0 border rounded-lg"
                  dropdownBodyClassname="w-auto border-0"
                  dropdownValue={data?.docType}
                  listItemOnClick={(e) => {
                    e.stopPropagation();
                    handleDropdownChange(index, e.target.textContent);
                    toggleDropdown(index);
                  }}
                />
                <input
                  type="file"
                  onChange={(e) => {
                    handleFileChange(index, e.target.files?.[0] || null);
                  }}
                  ref={(el) => (fileInputRefs.current[index] = el)}
                  className="hidden"
                  id={`doc-upload-${index}`}
                />
                <label
                  htmlFor={`doc-upload-${index}`}
                  className={`w-44 flex items-center justify-center text-center mx-2 cursor-pointer ${data?.file !== null
                    ? "bg-green-600 hover:bg-green-500"
                    : "bg-[#023496] hover:bg-gray-500"
                    } text-white-100 font-semibold delay-100 duration-100 transition-all py-3 rounded-md`}
                  onClick={() => clearFileInput()}
                >
                  <span className="delay-100 duration-100 transition-all relative">
                    {data?.file === null ? "Upload" : "Uploaded"}
                  </span>
                </label>
                <button
                  onClick={handleAddField}
                  className="p-3 px-5 rounded-lg border"
                >
                  +
                </button>

                {data?.file !== null && (
                  <button
                    onClick={() => handleRemoveFile(index)}
                    className="p-3 px-4"
                  >
                    <img src={CrossBG} className="w-12 h-12" />
                  </button>
                )}
              </div>
            ))}
          </div>
          {uploadDocErrMsg && (
            <Typograpy tagType="span" className="text-error">
              {uploadDocErrMsg}
            </Typograpy>
          )}
          <div className="flex items-center justify-between">
            {rejectTrxnStatus && (
              <label className="flex items-center w-full">
                <input
                  id="selectDocUpload"
                  type="checkbox"
                  onChange={(event) => {
                    event.stopPropagation();
                    setIsAllDocumentUpload((prev) => !prev);
                  }}
                  className="hidden"
                />
                <div className="w-5 h-5 border-2 border-[#292D32] rounded-lg">
                  {isAllDocumentUpload && <img src={Tick} />}
                </div>
                <span className="pl-2">All pending documents are uploaded</span>
              </label>
            )}
            <div className="flex items-center justify-end space-x-3">
              <Button
                bgColor="bg-[#023496]"
                fontStyle={{
                  fontFamily: "font-ssp",
                  fontSize: "text-base",
                  fontWeight: "font-bold",
                  fontColor: "text-white",
                }}
                borderStyle={{
                  borderRadius: "rounded",
                }}
                className="px-6 py-2"
                isLoading={customLoad.uploadDocsLoad}
                onClickHandler={handleUploadDocs}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>{" "}
      </Modal>
      <Modal
        visible={isCancelModalOpen}
        closeHandler={() => setIsCancelModalOpen(false)}
        header="Cancel Transaction"
        modalClass="rounded-md pt-1 pb-2"
        headerClass="text-xl font-medium"
      >
        <Typograpy tagType="h4" className="mt-6 text-lg">
          Are you sure you want to cancel the transaction?
        </Typograpy>
        {cancelTransactionError && (
          <ErrorField
            errorMessage={cancelTransactionError}
            errorClassname="text-red-500"
          />
        )}
        <div className="flex items-center justify-end mt-4 mb-2 space-x-4">
          <Button
            bgColor="bg-primary"
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-lg",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="px-6 py-2"
            isLoading={customLoad.cancelTransactionLoad}
            onClickHandler={cancelTransaction}
          >
            Yes
          </Button>
          <Button
            bgColor="bg-primary"
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-lg",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="px-6 py-2"
            onClickHandler={() => setIsCancelModalOpen(false)}
          >
            No
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default HistoryPage;
